import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../SvgIcon';

const DuplicateCell = React.memo(({ value, onDuplicateClick }) => {
	return (
		<div className="action-button">
			<button
				className={`edit`}
				onClick={ev => {
					return onDuplicateClick(value);
				}}>
				<SvgIcon icon="duplicate" />
			</button>
		</div>
	);
});

DuplicateCell.propTypes = {
	row: PropTypes.number,
	td: PropTypes.string,
	col: PropTypes.number,
	prop: PropTypes.string,
	value: PropTypes.any,
	onDuplicateClick: PropTypes.func,
};

export default DuplicateCell;
